import { useMutation } from "@tanstack/react-query";

import { useApiClient } from "../useApiClient";
import type { components } from "../schema";

type SubmitFeedbackBody = components["schemas"]["SubmitFeedbackBody"];
type FeedbackResponse = components["schemas"]["FeedbackResponse"];

// Posts an in-app feedback / bug report (L0-U6). The endpoint is public
// (optional-auth): the request goes through whether or not a session token is
// attached, so a logged-out -- or just-logged-out -- user can still report.
// Write-only, so nothing is invalidated on success.
export function useSubmitFeedback() {
  const client = useApiClient();
  return useMutation<FeedbackResponse, Error, SubmitFeedbackBody>({
    mutationFn: async (body) => {
      const { data, error } = await client.POST("/api/public/feedback", {
        body,
      });
      if (error !== undefined) {
        throw new Error("Failed to submit feedback");
      }
      return data;
    },
  });
}
